import React from 'react';
import { Table } from "react-bootstrap";
import { Link } from 'react-router-dom';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import Spinner from 'layouts/public/spinner/Spinner'

class InvoicesStatus extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
        return { loading: true };
    }

    componentDidMount() {
		this.get();
    }

	get = () => {
        new API().post(APIModules.Admin.url('/sponsorDashboard/getInvoicesStatus'), null,
            {
                success: (r) => {
                    this.setState({...r.data, loading: false});
                }
			});
    }

	render() {
		if (this.state.loading)
			return <Spinner />

		return (
			<Table condensed>
				<thead>
					<tr>
						<th className="col-md-2">Sent</th>
						<th className="col-md-2">Paid</th>
						<th className="col-md-2">MAP</th>
						<th className="col-md-2"></th>
					</tr>
				</thead>
				<tbody>
				<tr>
					<td className="react-grid-Cell">
						{this.state.sent > 0 ?
							<Link to={'/admin/paypalInvoiceSetup?status=SENT'}>
								{this.state.sent}
							</Link>
						:
							<span>-</span>
						}
					</td>
					<td className="react-grid-Cell">
						{this.state.paid > 0 ?
							<Link to={'/admin/paypalInvoiceSetup?status=PAID'}>
								{this.state.paid}
							</Link>
						:
							<span>-</span>
						}
					</td>
					<td className="react-grid-Cell">
						{this.state.map > 0 ?
							<Link to={'/admin/paypalInvoiceSetup?status=MARKED_AS_PAID'}>
								{this.state.map}
							</Link>
						:
							<span>-</span>
						}
					</td>
					<td></td>
				</tr>
				</tbody>
			</Table>
		)
	}
}

export default InvoicesStatus;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminSponsorDashboard/invoicesStatus/InvoicesStatus.js